<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2026-03-26</p>
    <div class="content">
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <div class="content-section image-section">
        <div class="image-container" v-if="currentNews.other?.picture1?.url">
          <img :src="currentNews.other?.picture1?.url">
        </div>
        <div class="image-placeholder" v-else>图片位置 1</div>
      </div>

      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <div class="content-section image-section">
        <div class="image-container" v-if="currentNews.other?.picture2?.url">
          <img :src="currentNews.other?.picture2?.url">
        </div>
        <div class="image-placeholder" v-else>图片位置 2</div>
      </div>

      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'chaodaokepujinxiaoyuan');
  return newsItem || {};
});
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}

.content-section {
  margin-bottom: 20px;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-placeholder {
  width: 100%;
  max-width: 720px;
  height: 360px;
  margin: 10px auto;
  border: 1px dashed #c9ced6;
  border-radius: 4px;
  color: #8b95a1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f9fc;
}
</style>
